import Swiper from "swiper";
import { Navigation } from 'swiper/modules';
import "swiper/css";

const campaignsSlider = () => {
    const $container = document.querySelector('.campaigns-slider-block');

    if (!$container) return;

    const sliderContainer = $container.querySelector('.js-campaigns-slider');

    if (sliderContainer) {
        const swiper = new Swiper(sliderContainer, {
            modules: [Navigation],
            slidesPerView: "auto",
            spaceBetween: 24,
            watchOverflow: true,
            speed: 1000,
            navigation: {
                nextEl: $container.querySelector('.js-button-campaign-next'),
                prevEl: $container.querySelector('.js-button-campaign-prev'),
            },
        });
    }
};

export default campaignsSlider;